import styled from 'styled-components';
import Input from 'common/ui/Input';
import Text from 'common/ui/Text';
import TextArea from 'common/ui/TextArea';
import type { ThemedStyledProps } from 'styled-components';

export type FieldsetProps = {
  noGutter?: boolean;
};

const Fieldset = styled.section`
  margin-bottom: ${
    // @ts-expect-error [EN-10263] - TS2769 - No overload matches this call.
    (props: ThemedStyledProps<FieldsetProps, never>) => (props.noGutter === true ? 0 : 20)
  }px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  min-width: 0;

  &:last-of-type {
    margin-bottom: 0;
  }

  ${Text} {
    margin-bottom: 10px;
  }

  ${Input}, ${TextArea} {
    margin: 0 -15px;
  }
`;

export default Fieldset;
